import { useNavigate, useLocation } from 'react-router-dom';

// styles
import {
    SubNavHeaderContainer,
    SubNavItem
} from './SubNavHeader.styles.js';

export default function SubNavHeader({ navItems }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = (path) => {
    navigate(path);
  }

  return (
    <SubNavHeaderContainer>
      {navItems.map((item) => {
        const isActive = location.pathname === item.path;
        return (
          <SubNavItem
            key={item.path}
            $isActive={isActive}
            onClick={() => handleNavigate(item.path)}
          >
            <p>{item.title}</p>
          </SubNavItem>
        );
      })}
    </SubNavHeaderContainer>
  );
}